import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { SideBarState } from "../../common/types/SliceTypes";
import { RootState } from "../store";
import { AXIOS } from "../../api/axios";

const initial: SideBarState = {
  reminders: [],
  receivedDocIds: [],
  sharedDocIds: [],
};

export const sidebarSlice = createSlice({
  name: "sideBar",
  initialState: initial,
  reducers: {
    setReminders: (state, action) => {
      state.reminders = action.payload;
    },
    setReceivedDocIds: (state, action) => {
      state.receivedDocIds = action.payload;
    },
    setSharedDocIds: (state, action) => {
      state.sharedDocIds = action.payload;
    },
  },
});

export const { setReminders, setReceivedDocIds, setSharedDocIds } =
  sidebarSlice.actions;

export default sidebarSlice.reducer;

export const selectReminders = (state: RootState) => state.sidebar.reminders;

export const selectRecievedDocIds = (state: RootState) =>
  state.sidebar.receivedDocIds;

export const selectShareDocIds = (state: RootState) =>
  state.sidebar.sharedDocIds;

export const fetchReminders = createAsyncThunk(
  "reminders/",
  async (_, { getState }) => {
    const state = getState() as RootState;
    let url =
      process.env.REACT_APP_API_BASE_URL + "reminder/" + state.user.externalId;
    try {
      const response = await AXIOS.get(url);
      return response.data.data;
    } catch (err) {
      console.error(err);
    }
  }
);

export const fetchSharedDocsForUser = createAsyncThunk(
  "shared/to",
  async (_, { getState }) => {
    const state = getState() as RootState;
    let url =
      process.env.REACT_APP_API_BASE_URL +
      "filter/shared/to/" +
      state.user.externalId;
    try {
      const response = await AXIOS.get(url);
      return response.data.data;
    } catch (err) {
      console.error(err);
    }
  }
);

export const fetchSharedDocsByUser = createAsyncThunk(
  "shared/by",
  async (_, { getState }) => {
    const state = getState() as RootState;
    let url =
      process.env.REACT_APP_API_BASE_URL +
      "filter/shared/by/" +
      state.user.externalId;
    try {
      const response = await AXIOS.get(url);
      return response.data.data;
    } catch (err) {
      console.error(err);
    }
  }
);
